<template>
  <svg
    :class="['icon', size]"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 42.21 37.08"
  >
    <g>
      <path
        class="cls-1"
        d="M40.61,26.53c-.88,0-1.6.72-1.6,1.6v5.76H3.2v-5.76c0-.88-.72-1.6-1.6-1.6s-1.6.72-1.6,1.6v7.36c0,.88.72,1.6,1.6,1.6h39.01c.88,0,1.6-.72,1.6-1.6v-7.36c0-.88-.72-1.6-1.6-1.6Z"
      />
      <path
        class="cls-1"
        d="M19.97,28.39s.07.06.1.08c.05.04.09.08.14.11.04.03.09.05.14.08.05.02.09.05.14.07.05.02.11.03.16.05.05.01.09.03.14.04.1.02.21.03.31.03s.21-.01.31-.03c.05,0,.09-.03.14-.04.05-.02.11-.03.16-.05.05-.02.09-.05.14-.07.05-.02.09-.05.14-.08.05-.03.09-.08.14-.11.03-.03.07-.05.1-.08l6.79-6.79c.62-.62.62-1.64,0-2.26-.62-.62-1.64-.62-2.26,0l-4.06,4.06V1.6c0-.88-.72-1.6-1.6-1.6s-1.6.72-1.6,1.6v21.8l-4.06-4.06c-.62-.62-1.64-.62-2.26,0-.62.62-.62,1.64,0,2.26l6.79,6.79Z"
      />
    </g>
  </svg>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    size: {
      type: String,
      default: 'size'
    }
  }
})
</script>

<style lang="scss" scoped>
.icon {
  fill: currentColor;
  stroke-width: 0;
}
.size {
  width: 1em;
  height: 1em;
}
.lg {
  width: 1.25em;
  height: 1.25em;
}
.sm {
  width: 0.85em;
  height: 0.85em;
}
</style>
